// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveSecondaryProgramCourseHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SecondaryProgramCourseDTO from '../models/SecondaryProgramCourseDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    secondaryProgramCourseId: string | null | null;
    secondaryProgramCourse: SecondaryProgramCourseDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            secondaryProgramCourseId: null,
            secondaryProgramCourse: null,
        },
        initValues);
    },
    secondaryProgramCourseId: 'secondaryProgramCourseId',
    secondaryProgramCourse: 'secondaryProgramCourse',
}

interface Result extends ResultDTO {
    secondaryProgramCourse: SecondaryProgramCourseDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            secondaryProgramCourse: null,
        },
        initValues);
    },
    secondaryProgramCourse: 'secondaryProgramCourse',
}

export { Request, Result };